<script setup lang="ts">
import { XCircle, X } from 'lucide-vue-next'

interface Props {
  message?: string
  title?: string
}

const props = withDefaults(defineProps<Props>(), {
  message: 'An error occurred. Please try again.',
  title: 'Error'
})
</script>
  
<template>
  <div class="relative pointer-events-auto w-full max-w-sm overflow-hidden rounded-xl bg-white/95 backdrop-blur-md shadow-xl ring-1 ring-black/5 border-l-4 border-red-500 font-inter animate-slide-in">
    <div class="p-4">
      <div class="flex items-start">
        <!-- Icon Container -->
        <div class="shrink-0">
          <div class="w-8 h-8 bg-gradient-to-br from-red-500/10 to-red-600/10 rounded-lg flex items-center justify-center">
            <XCircle class="h-5 w-5 text-red-500" aria-hidden="true" />
          </div>
        </div>
        
        <!-- Content -->
        <div class="ml-3 w-0 flex-1 pt-0.5">
          <p v-if="title" class="text-sm font-semibold text-red-500 mb-1">{{ title }}</p>
          <p class="text-sm font-medium text-gray-700 leading-relaxed">{{ message }}</p>
        </div>
        
        <!-- Close Button (optional) -->
        <div class="ml-4 flex shrink-0">
          <button 
            type="button" 
            class="inline-flex rounded-lg p-1 text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
          >
            <span class="sr-only">Close</span>
            <X class="h-4 w-4" aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@keyframes slide-in {
  from { 
    opacity: 0; 
    transform: translateX(-100%); 
  }
  to { 
    opacity: 1; 
    transform: translateX(0); 
  }
}
.animate-slide-in {
  animation: slide-in 0.5s cubic-bezier(0.4,0,0.2,1);
}
</style>
  